/* =========================================
   MOBILE CURTAIN NAVIGATION CONTROLLER
   ========================================= */
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

document.addEventListener('DOMContentLoaded', () => {
    // Auto-update footer year
    const yearEl = document.getElementById('current-year');
    if (yearEl) yearEl.textContent = new Date().getFullYear();

    const toggleBtn = document.querySelector('.mobile-menu-toggle');
    const overlay = document.querySelector('.mobile-menu-overlay');
    const navLinks = document.querySelectorAll('.mobile-overlay-link');
    
    let isMenuOpen = false;
    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (toggleBtn && overlay) {
        toggleBtn.addEventListener('click', () => {
            isMenuOpen = !isMenuOpen;
            
            toggleBtn.setAttribute('aria-expanded', isMenuOpen);
            toggleBtn.classList.toggle('open', isMenuOpen);
            overlay.setAttribute('aria-hidden', !isMenuOpen);
            
            if (isMenuOpen) {
                // Initialize timeline to coordinate simultaneous animations
                const tl = gsap.timeline();
                
                // Show grid system immediately
                gsap.set(overlay, { display: 'flex' });
                
                // Stop background scrolling
                document.body.style.overflow = 'hidden';
                
                // Reset elements to starting positions
                gsap.killTweensOf([overlay, navLinks]);
                gsap.set(overlay, { translateY: '-100%' });
                gsap.set(navLinks, { y: 40, opacity: 0 });
                
                // Drop the curtain and spring-stagger the pills into place simultaneously
                tl.to(overlay, {
                    translateY: '0%',
                    duration: isReduced ? 0 : 0.45,
                    ease: 'power3.out'
                })
                .to(navLinks, {
                    y: 0,
                    opacity: 1,
                    duration: isReduced ? 0 : 0.45,
                    stagger: isReduced ? 0 : 0.05,
                    ease: 'back.out(1.2)' // Playful springy effect similar to Framer Motion/React Bits
                }, isReduced ? 0 : '-=0.32'); // Overlap link entrance with the curtain slide for a highly responsive feel
                
            } else {
                const tl = gsap.timeline();
                
                // Restore scroll accessibility
                document.body.style.overflow = '';
                
                gsap.killTweensOf([overlay, navLinks]);
                
                // Stagger links out and slide curtain back up simultaneously
                tl.to(navLinks, {
                    opacity: 0,
                    y: isReduced ? 0 : -20,
                    duration: isReduced ? 0 : 0.2,
                    stagger: isReduced ? 0 : 0.03,
                    ease: 'power2.in'
                })
                .to(overlay, {
                    translateY: '-100%',
                    duration: isReduced ? 0 : 0.35,
                    ease: 'power3.inInOut',
                    onComplete: () => {
                        overlay.style.display = 'none';
                    }
                }, isReduced ? 0 : '-=0.15'); // Sweeps curtain up smoothly as links are fading
            }
        });
        
        // Close overlay instantly if any link is clicked
        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (isMenuOpen) {
                    toggleBtn.click();
                }
            });
        });
    }
});

